/**
 * The listener sits on `document` rather than on `this.el`: the timeline is rendered by the dead page
 * around this LiveView, so the controls are never inside the hook's own element.
 */
export const AutomationModalOpener = {
  mounted() {
    // A reconnect can mount the hook again without destroying it first, which would push every click twice.
    this.stopListening();

    this.open = (control) => {
      this.pushEvent("open_automation", {
        mode: control.dataset.automationModal,
        id: control.dataset.automationId,
      });
    };

    this.onClick = (event) => {
      const control = event.target.closest("[data-automation-modal]");
      if (control) this.open(control);
    };
    document.addEventListener("click", this.onClick);

    // Space/Enter activation for the modal case, whose root is a `<div role="button" tabindex="0">`
    // rather than a native control — those don't get key activation for free.
    this.onKeydown = (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;

      const control = event.target.closest("[data-automation-modal]");
      if (!control) return;

      if (event.key === " ") event.preventDefault();
      this.open(control);
    };
    document.addEventListener("keydown", this.onKeydown);
  },
  destroyed() {
    this.stopListening();
  },
  stopListening() {
    if (this.onClick) document.removeEventListener("click", this.onClick);
    if (this.onKeydown) document.removeEventListener("keydown", this.onKeydown);
    this.onClick = null;
    this.onKeydown = null;
  },
};
